/*!
 * @license
 * Copyright © 2005-2023 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { ActionDefinitionEntry } from '../model/actionDefinitionEntry';
import { ActionDefinitionList } from '../model/actionDefinitionList';
import { ActionExecResultEntry } from '../model/actionExecResultEntry';
import { BaseApi } from './base.api';
import { throwIfNotDefined } from '../../../assert';
import { buildCollectionParam } from '../../../alfrescoApiClient';
export class ActionsApi extends BaseApi {
    actionDetails(actionDefinitionId) {
        throwIfNotDefined(actionDefinitionId, 'actionDefinitionId');
        const postBody = null;
        const pathParams = {
            'actionDefinitionId': actionDefinitionId
        };
        const queryParams = {};
        const headerParams = {};
        const formParams = {};
        const contentTypes = ['application/json'];
        const accepts = ['application/json'];
        return this.apiClient.callApi('/action-definitions/{actionDefinitionId}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, contentTypes, accepts, ActionDefinitionEntry);
    }
    actionExec(actionBodyExec) {
        throwIfNotDefined(actionBodyExec, 'actionBodyExec');
        const postBody = actionBodyExec;
        const pathParams = {};
        const queryParams = {};
        const headerParams = {};
        const formParams = {};
        const contentTypes = ['application/json'];
        const accepts = ['application/json'];
        return this.apiClient.callApi('/action-executions', 'POST', pathParams, queryParams, headerParams, formParams, postBody, contentTypes, accepts, ActionExecResultEntry);
    }
    listActions(opts) {
        opts = opts || {};
        const postBody = null;
        const pathParams = {};
        const queryParams = {
            'skipCount': opts['skipCount'],
            'maxItems': opts['maxItems'],
            'orderBy': buildCollectionParam(opts['orderBy'], 'csv'),
            'fields': buildCollectionParam(opts['fields'], 'csv')
        };
        const headerParams = {};
        const formParams = {};
        const contentTypes = ['application/json'];
        const accepts = ['application/json'];
        return this.apiClient.callApi('/action-definitions', 'GET', pathParams, queryParams, headerParams, formParams, postBody, contentTypes, accepts, ActionDefinitionList);
    }
    nodeActions(nodeId, opts) {
        throwIfNotDefined(nodeId, 'nodeId');
        opts = opts || {};
        const postBody = null;
        const pathParams = {
            'nodeId': nodeId
        };
        const queryParams = {
            'skipCount': opts['skipCount'],
            'maxItems': opts['maxItems'],
            'orderBy': buildCollectionParam(opts['orderBy'], 'csv'),
            'fields': buildCollectionParam(opts['fields'], 'csv')
        };
        const headerParams = {};
        const formParams = {};
        const contentTypes = ['application/json'];
        const accepts = ['application/json'];
        return this.apiClient.callApi('/nodes/{nodeId}/action-definitions', 'GET', pathParams, queryParams, headerParams, formParams, postBody, contentTypes, accepts, ActionDefinitionList);
    }
}
